// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../services/api';

const forgotPasswordService = async (data) => {
  return api(`/Sellitback.svc/ForgotPassword/${data.email}`, {}, 'GET');
};


export {
  forgotPasswordService,
};
